<form [formGroup]="form" class="stampa-nalepnica">
  <p class="izabrano">
    Izabrano: <strong>{{ artikliIds.length }} {{ artikliLabel }}</strong>
  </p>

  <section>
    <kodit-field
      fieldLabel="Cenovnik"
      fieldLabelFor="nalepnice-cenovnik"
      [isFieldRequired]="true"
    >
      <p-dropdown
        inputId="nalepnice-cenovnik"
        formControlName="cenovnikId"
        [options]="cenovnici"
        [filter]="true"
        filterBy="label"
        placeholder="Izaberite cenovnik"
        emptyMessage="Nema aktivnih cenovnika"
        appendTo="body"
        styleClass="cenovnik-dropdown"
      ></p-dropdown>
    </kodit-field>
  </section>

  <section>
    <kodit-field fieldLabel="Artikli van cenovnika">
      <div
        *ngFor="let opcija of vanCenovnikaOptions"
        class="p-field-radiobutton"
      >
        <p-radioButton
          [inputId]="'nalepnice-van-' + opcija.value"
          [value]="opcija.value"
          formControlName="artikalVanCenovnika"
        ></p-radioButton>
        <label [for]="'nalepnice-van-' + opcija.value">{{
          opcija.label
        }}</label>
      </div>
      <small class="napomena">
        Artikli kojih nema ni u osnovnom cenovniku se uvek izostavljaju.
      </small>
    </kodit-field>
  </section>

  <section>
    <kodit-field fieldLabel="Polja na nalepnici" [isFieldRequired]="true">
      <div class="polja">
        <div *ngFor="let polje of poljaOptions" class="p-field-checkbox">
          <p-checkbox
            name="nalepnice-polja"
            [inputId]="'nalepnice-polje-' + polje.value"
            [value]="polje.value"
            [formControl]="poljaCtrl"
          ></p-checkbox>
          <label [for]="'nalepnice-polje-' + polje.value">{{
            polje.label
          }}</label>
        </div>
      </div>
      <small *ngIf="!poljaCtrl.value?.length" class="p-error">
        Izaberite bar jedno polje.
      </small>
    </kodit-field>
  </section>

  <section>
    <kodit-field fieldLabel="Raspored na A4 stranici">
      <p-selectButton
        [options]="kolonaOptions"
        formControlName="brojKolona"
      ></p-selectButton>
    </kodit-field>
  </section>

  <section *ngIf="izostavljeni.length" class="izostavljeni">
    <p class="izostavljeni-naslov">
      <i class="fa-light fa-triangle-exclamation p-mr-1"></i>
      <ng-container *ngIf="nijedanZaStampu; else delimicno">
        {{ nemaArtikalaZaStampu }}
      </ng-container>
      <ng-template #delimicno>
        Izostavljeno: {{ izostavljeni.length }}
      </ng-template>
    </p>
    <ul>
      <li *ngFor="let artikal of izostavljeni">
        <span *ngIf="artikal.sifra" class="sifra">{{ artikal.sifra }}</span>
        {{ artikal.naziv }}
        <span *ngIf="artikal.razlog" class="razlog">– {{ artikal.razlog }}</span>
      </li>
    </ul>
  </section>

  <div class="akcije">
    <button
      pButton
      type="button"
      label="Otkaži"
      class="p-button-outlined"
      (click)="onOtkazi()"
    ></button>
    <p-button
      label="Generiši PDF"
      icon="fa-light fa-file-pdf"
      [loading]="isGenerating"
      [disabled]="isGenerisiDisabled"
      (onClick)="onGenerisi()"
    ></p-button>
  </div>
</form>
